import Select from "react-select";
import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Container, Form, Row, Table } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import SparkApi from "../../api/SparkApi";
import jsPDF from "jspdf";
import "./transaction.css";
import { DatatableWrapper, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import InfoPill from "../InfoPill";
import { Link } from "react-router-dom";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { usePermission } from "../context/PermissionContext";
import jwtDecode from "jwt-decode";

const ProductDetailsReports = () => {
  const [filteredInventory, setFilteredInventory] = useState([]);  
  const [searchText, setSearchText] = useState();
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [rackOptions, setRackOptions] = useState([]);
  const [factoryData, setFactoryData] = useState([]);
  const [loadDate , setLoadDate] = useState(false);
  const [selectedIds, setSelectedIds] = useState({
    productId: [],
    rackId: [],
    warehouseId: [],
    factoryId: [],
    categoryId: [],
    type: "",
    startDate: "",
    endDate: "",
    startTime :"",
    endTime :"",
  });
  const [searchedPro , setSearchedPro] = useState([]);
  const [resetTriggered, setResetTriggered] = useState(false);
  const [isScannerVisible, setScannerVisible] = useState(false);
  const [categories , setCategories] = useState([]);

  /*  Permissions */
  const token = sessionStorage.getItem("token");
  const userInfo = jwtDecode(token);
  const { permissionData } = usePermission();
  const inventoryPermission = permissionData?.length > 0 ? permissionData?.find((obj) => obj?.name?.trim() === 'Inventory Report') : null;
  const can_read = inventoryPermission?.can_read;

  /*---------  Start barcode ----------------*/
  const [barcodeRead, setBarcodeRead] = useState();
  const barcodeRef = useRef({
      timing: 0,
      data: "",
  });

  useEffect(() => {
      const barcodeReaded = () => {
          if (barcodeRef.current.data.length > 1 && (barcodeRef.current.data.includes("PRO") || barcodeRef.current.data.includes("RAC"))) {
              setBarcodeRead(barcodeRef.current.data.split("E")[0]);
          }
          barcodeRef.current = { timing: 0, data: "" };
      };

      let timeout;

      const handleKeypress = (e) => {
          const currentTime = e.timeStamp;
          const isWithinInterval =
              currentTime - barcodeRef.current.timing < 200;

          if (barcodeRef.current.data.length === 0 || isWithinInterval) {
              clearTimeout(timeout);
              barcodeRef.current.data += e.key;
              barcodeRef.current.timing = currentTime;
              timeout = setTimeout(barcodeReaded, 300);
          } else {
              clearTimeout(timeout);
              barcodeRef.current = {
                  timing: currentTime,
                  data: e.key,
              };
          }
      };

      window.addEventListener("keypress", handleKeypress);

      return () => {
          window.removeEventListener("keypress", handleKeypress);
          clearTimeout(timeout);
      };
  }, []);

  useEffect(() => {
      if (barcodeRead) {
          fetchProductDetails();
      }
  }, [barcodeRead]);

  const fetchProductDetails = async () => {
      try {          
          const productResult = await SparkApi.fetchScannedProductDetails(barcodeRead);
  
          if (productResult.success) {
              setProductOptions([]);
              const selectedValues = productResult?.records?.map((result) => result?.result?.product_id) || [];
              
              setSelectedIds((prev) => ({
                  ...prev,
                  productId: [...prev.productId, ...selectedValues],
              }));

              setSearchedPro((prev) => {
                  const newProduct = {
                      label: productResult?.records[0]?.result?.product_name,
                      value: productResult?.records[0]?.result?.product_id,
                  };
                  const updatedProducts = prev.filter((product) => product.value !== newProduct.value);
                  return [...updatedProducts, newProduct];
              });  
              // after scan a product data fetch automatically. 
              setResetTriggered(true);
          } else {
          }
      } catch (error) {
      }
  };    
  //------------ End barcode ----------------

  /*  Set Default Start / End Date in Date Filed  */
  const setDfaultDates = async () => {
    const date = new Date();

    let endDay = date.getDate();
    let formattedEndDay = endDay.toString().padStart(2, '0');
    let endMonth = date.getMonth() + 1;
    let formattedEndMonth = endMonth.toString().padStart(2, '0');
    let endYear = date.getFullYear();
    const endDate = `${endYear}-${formattedEndMonth}-${formattedEndDay}`;

    const startDateObj = new Date(date);
    startDateObj.setDate(date.getDate() - 30);
    let startDay = startDateObj.getDate();
    let formattedStartDay = startDay.toString().padStart(2, '0');
    let startMonth = startDateObj.getMonth() + 1;
    let formattedStartMonth = startMonth.toString().padStart(2, '0');
    let startYear = startDateObj.getFullYear();
    const startDate = `${startYear}-${formattedStartMonth}-${formattedStartDay}`;

    setSelectedIds((prev) => ({
      ...prev ,
      startdate: startDateObj,
      enddate: date,
      startDate: startDate,
      endDate: endDate,
    }));

    setLoadDate(true);

    // return {
    //   startdate: startDateObj,
    //   enddate: date,
    //   startDate: startDate,
    //   endDate: endDate,
    // }
  }

  useEffect(() => {
    fetchWarehouses();
    fetchProducts();
    fetchRacks();
    fetchFactory();
    fetchActiveCategories();
    setDfaultDates();

    // if (selectedIds?.endDate && selectedIds?.startDate) { 
    //   applyFilters();
    // }

  }, []);

  useEffect(() => {
    if (selectedIds?.endDate && selectedIds?.startDate) {
      applyFilters();
    }
  }, [loadDate]);

  const fetchActiveCategories = async () => {
    try {
        const result = await SparkApi.getProductCategory();
        if (result.success) {
            if (result && Array.isArray(result?.records)) {
                setCategories(
                    result?.records?.filter((obj) => obj?.status === 'active').map((sub) => ({
                        value: sub.id,
                        label: sub.category,
                        status: sub.status,
                    }))
                );
            }
        }
    } catch (error) {
        console.error("Error fetch categories :", error);
    }
  }

  const fetchFactory = async () => {
    try {
      const result = await SparkApi.fetchFactory();
      if (result && Array.isArray(result)) {
        setFactoryData(
          result.map((sub) => ({ value: sub.id, label: sub.name }))
        );
      } else if (result) {
        setFactoryData([{ value: result.id, label: result.name }]);
      }
    } catch (err) {
      console.error("Error fetching factory:", err);
    }
  };

  const fetchWarehouses = async () => {
    try {
      const warehouses = await SparkApi.fetchWarehouse();
      setWarehouseOptions(
        warehouses.map((sub) => ({
          value: sub.id,
          label: sub.name,
          factory_id: sub.factory_id,
        }))
      );
    } catch (error) {
      console.error("Error fetching warehouses:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      if (searchText?.trim()) {
        const products = await SparkApi.getProductsBySearch(searchText);

        if (products.success) {
          const options = products?.records?.map((ProRec) => ({
            value: ProRec.id,
            label: ProRec.name,
          }));
          setProductOptions(options);
        } else {
          setProductOptions([]);
        }
      } else {
        setProductOptions([]);
      }
    } catch (error) {
      setProductOptions([]);
    }
  };

  const fetchRacks = async () => {
    try {
      const racks = await SparkApi.fetchRacks();
      setRackOptions(
        racks.data.map((rackRec) => ({
          value: rackRec.id,
          label: rackRec.name,
          warehouse_id: rackRec.warehouse_id,
        }))
      );
    } catch (error) {
      console.error("Error fetching racks:", error);
    }
  };

  const applyFilters = async () => {
    const appliedFilters = { ...selectedIds };
    
    try {
      let report;

      report = await SparkApi.reportDetailsFilter(appliedFilters);

      if (report) {
        setFilteredInventory(report);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    }
  };

  const resetFilters = () => {
    setSelectedIds({
      productId: [],
      rackId: [],
      warehouseId: [],
      factoryId: [],
      categoryId : [],
      type: "",
      startDate: "",
      endDate: "",
      startTime : "",
      endTime : "",
    });
    setDfaultDates();
    setResetTriggered(true);  
  };

  useEffect(() => {
    if (resetTriggered) {
        applyFilters();  
        setResetTriggered(false);  
    }
  }, [resetTriggered]);

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    doc.setFontSize(12);
    doc.text("Inventory Transactions Reports", 14, 10);

    const tableData = filteredInventory?.records?.map((row) => [
      row?.product_name,
      row?.factory_name,
      row?.warehouse_name,
      row?.rack_name,
      row?.formatted_date,
      row?.type,
      row?.quantity,
    ]);      

    doc.autoTable({
      head: [
        [
          "Product Name",
          "Factory Name",
          "Warehouse Name",
          "Rack Name",
          "Date",
          "Type",
          "Qty",
        ],
      ],
      body: tableData,
      didDrawCell: (data) => {
        doc.setLineDash([1, 1], 0);
      },
      styles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      columnStyles: {
        6: { halign: 'right' }
      },
      margin: { top: 20 },
    });

    doc.save("Inventory_Transactions_Report.pdf");
  };

  const labels = {
    beforeSelect: " ",
  };

  const headers = [
    { title: "Product Name", prop: "", isFilterable: true , 
      cell: (row) => (
        <Link to={`/productview/${row.product_id}`} state={row}>
          {row.product_name}
        </Link>
      ),
     },
    { title: "Factory Name", prop: "factory_name", isFilterable: true },
    { title: "Warehouse Name", prop: "warehouse_name", isFilterable: true},
    { title: "Rack Name", prop: "rack_name", isFilterable: true },
    { title: "Date", prop: "formatted_date", isFilterable: true },
    { title: "Type", prop: "type", isFilterable: true , 
      cell : (row) => (
          row?.type === 'check-in' ? (<span>Check-In</span>) : (<span>Check-Out</span>)
    ), 
    },
    { title: "Qty", prop: "quantity", isFilterable: true },
  ];    

  const handleScanButton = () => {
    setScannerVisible(true);
  };
  
  return (
    <Container>
      <Row className="my-3">
          <Col lg={12} className="text-center">
            <div style={{ textAlign: "center" }}>
                {isScannerVisible && (
                    <BarcodeScannerComponent
                      width={250}
                      height={250}
                      facingMode="environment"
                      onUpdate={(err, result) => {
                      if (result){
                          setBarcodeRead(result?.text);
                          setScannerVisible(false);
                      } 
                      else {
                          setBarcodeRead(null)
                      }
                      }}
                    />
                )}
            </div>
            <Card>
              <Card.Header className="fw-bold ">
                <div className="text-center">Inventory Transactions Reports</div>
              </Card.Header>

              <Card.Body>
                  <Row className="mb-3 g-2">
                      <Col lg={4}>
                        <Select
                          isMulti
                          id="product_id"
                          name="product_id"
                          options={productOptions || searchedPro}
                          value={searchedPro?.filter((option) => selectedIds?.productId?.includes(option.value))}
                          onInputChange={(inputValue) => {
                              setSearchText(inputValue);
                              fetchProducts();
                          }}

                          onChange={(selectedOptions) => {
                              const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                      
                              setSelectedIds((prev) => ({
                                  ...prev,
                                  productId: selectedValues, 
                              }));
                      
                              setSearchedPro((prev) => {
                                  const updatedProducts = selectedOptions
                                      ? selectedOptions.map((option) => ({
                                          label: option.label,
                                          value: option.value,
                                      }))
                                      : [];
                      
                                  const uniqueProducts = [
                                      ...new Map([
                                          ...prev,
                                          ...updatedProducts,
                                      ].map((item) => [item.value, item])).values(),
                                  ];
                      
                                  return uniqueProducts;
                              });
                          }}
                          isClearable={true}
                          isSearchable={true}
                          placeholder="--Enter Product Name--"
                          required
                        />
                      </Col>

                      <Col lg={4}>
                        <Select
                            isMulti
                            name="factory"
                            options={factoryData}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select Factory"
                            value={factoryData?.filter((option) => selectedIds?.factoryId?.includes(option.value))}
                            onChange={(selectedOptions) => {
                              const selectedValues = selectedOptions ? selectedOptions?.map((option) => option.value) : [];
                              setSelectedIds((prev) => ({
                                ...prev,
                                factoryId: selectedValues,
                              }));
                            }}
                          />
                      </Col>

                      <Col lg={4}>
                        <Select
                          isMulti
                          name="warehouse"
                          options={warehouseOptions}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select Warehouse"
                          value={warehouseOptions?.filter((option) =>
                            selectedIds?.warehouseId?.includes(option.value)
                          )}
                          onChange={(selectedOptions) => {
                            const selectedValues = selectedOptions
                              ? selectedOptions?.map((option) => option.value)
                              : [];
                            setSelectedIds((prev) => ({
                              ...prev,
                              warehouseId: selectedValues,
                            }));
                          }}
                        />
                      </Col>

                      <Col lg={4}>
                        <Select
                            isMulti
                            name="rack"
                            options={rackOptions}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select Rack"
                            value={rackOptions?.filter((option) =>
                              selectedIds?.rackId?.includes(option.value)
                            )}
                            onChange={(selectedOptions) => {
                              const selectedValues = selectedOptions ? selectedOptions?.map((option) => option.value) : [];
                              setSelectedIds((prev) => ({
                                ...prev,
                                rackId: selectedValues,
                              }));
                            }}
                          />
                      </Col>

                      <Col lg={4}>
                        <Form.Select
                            name="checkInCheckOut"
                            value={selectedIds.type || ""}
                            onChange={(e) =>
                            setSelectedIds((prev) => ({
                                ...prev,
                                type: e.target.value,
                            }))
                            }
                        >
                            <option value="">All Types</option>
                            <option value="check-in">Check-In</option>
                            <option value="check-out">Check-Out</option>
                        </Form.Select>
                      </Col>

                      <Col lg={4} sm={6}>
                        <Select
                            isMulti
                            name="category"
                            options={categories}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select Category"
                            value={categories?.filter((option) => selectedIds?.categoryId?.includes(option.value))}
                            onChange={(selectedOptions) => {
                                const selectedValues = selectedOptions ? selectedOptions?.map((option) => option.value) : [];
                                setSelectedIds((prev) => ({
                                    ...prev,
                                    categoryId: selectedValues,
                                }));
                            }}
                        />
                    </Col>
                  </Row>

                  <Row className="mb-2">
                      <Col lg={3}>
                          <Form.Group className="d-flex align-items-center gap-2">
                              <Form.Label className="fw-bold start-date mb-0">Start Date</Form.Label>
                              <Form.Control
                                type="date"
                                name="startDate"
                                value={selectedIds?.startDate || ""}
                                onChange={(e) =>
                                    setSelectedIds((prev) => ({
                                    ...prev,
                                    startDate: e.target.value,
                                    startdate: new Date(e.target.value),
                                    }))
                                }
                              />
                          </Form.Group>
                      </Col>
                      <Col lg={3}>
                          <Form.Group className="d-flex align-items-center gap-2">
                              <Form.Label className="fw-bold end-date mb-0">End Date</Form.Label>
                              <Form.Control
                                type="date"
                                name="endDate"
                                value={selectedIds?.endDate || ""}
                                onChange={(e) =>
                                    setSelectedIds((prev) => ({
                                    ...prev,
                                    endDate: e.target.value,
                                    enddate: new Date(e.target.value),
                                    }))
                                }
                              />
                          </Form.Group>
                      </Col>
                      <Col lg={3}>
                        <Form.Group className="d-flex align-items-center">
                          <Form.Label className="fw-bold start-time mb-0">Start Time</Form.Label>
                          <Form.Control
                            type="time"
                            name="start_time"
                            placeholder="--Enter Start Time--"
                            value={selectedIds?.startTime}
                            onChange={(e) =>
                              setSelectedIds((prev) => ({
                              ...prev,
                              startTime: e.target.value,
                            }))
                          }
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={3}>
                        <Form.Group className="d-flex align-items-center">
                          <Form.Label className="fw-bold end-time mb-0">End Time</Form.Label>
                          <Form.Control
                            type="time"
                            name="end_time"
                            placeholder="Enter End Time"
                            value={selectedIds?.endTime}
                            onChange={(e) =>
                              setSelectedIds((prev) => ({
                              ...prev,
                              endTime: e.target.value,
                            }))
                          }
                          />
                        </Form.Group>
                      </Col>
                  </Row>
                  <Row>
                    <Col lg={4} className="d-flex align-items-center">
                      <Button className="reset-filters-btn btn-sm" variant="danger" onClick={resetFilters}>Reset</Button>
                      <Button className="apply-filters-btn btn-sm mx-2" variant="success" onClick={applyFilters}>Search</Button>
                      <Button disabled={filteredInventory?.records?.length > 0 ? false : true} className="btn btn-sm btn-primary float-end" onClick={downloadPDF}>Download</Button>
                      <Button className="btn-sm scanButton" onClick={handleScanButton}>Scan Barcode</Button>
                    </Col>
                  </Row>

                  <Row className="mt-3 border-top">
                      <Col lg={12} className="responseivTable">
                          <DatatableWrapper
                            headers={headers}
                            body={filteredInventory?.records || []}
                            paginationOptionsProps={{
                              initialState: {
                                rowsPerPage: 10,
                                options: [5, 10, 15, 20],
                              },
                            }}
                          >
                            <Row className="mb-4">
                              <Col lg={4} sm={4} className="d-flex flex-col justify-content-end align-items-end">
                              </Col>
                              <Col xs={12} sm={6} lg={6} className="d-flex flex-col justify-content-start align-items-start"                >
                                <PaginationOptions labels={labels} />
                                <div className="mt-2">
                                  <InfoPill
                                    left="Total Transaction"
                                    right={filteredInventory?.records?.length > 0 ? filteredInventory?.records?.length : 0}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Table striped className="transaction-report-table" responsive id="inventory-table-details">
                              <TableHeader />
                              {filteredInventory?.records?.length > 0 ? <TableBody /> : <TableBody><tr>
                                <td colSpan={7} className="text-center">No records found</td>
                              </tr></TableBody>}
                            </Table>
                            <Pagination />
                          </DatatableWrapper>
                      </Col>
                  </Row>
              </Card.Body>
            </Card>
          </Col>
      </Row>
    </Container>
  );
};

export default ProductDetailsReports;